import { combineReducers } from 'redux';
import selectReducers from './index';

const AutomaticSendReducer = combineReducers({
  selectReducers,
});

export default AutomaticSendReducer;
